import { map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { IncorrectPaymentCommand } from '../../command/incorrect-payment';
import { NavigationService } from '../../../core/service/navigation.service';
import { IncorrectPaymentService } from '../data/incorrect-payment.service';

@Injectable()
export class VoidIncorrectPaymentsCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: IncorrectPaymentService,
    private _navigationService: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      if (!command.items || !command.itemsSource) return false;
      return command.id === IncorrectPaymentCommand.voidIncorrectPayments;
    }
    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.voidIncorrectPayments(command.items.map(item => item.id)).pipe(
        switchMap(() => {
          this._navigationService.reloadCurrentRoute();
          return of(true);
        })
      );
    }
    if (command instanceof FilteredCommand) {
      return this._dataService
        .voidIncorrectPaymentsFiltered(
          command.filterProvider.filterState,
          command.includedIds,
          command.excludedIds,
          command.totalAffectedItemsControlValue
        )
        .pipe(map(() => true));
    }
  }
}
